/**
 * Starts a hold window and returns a settle() that resolves once at least
 * `ms` has passed since the call. Used to keep the ceremony animation on
 * screen long enough that a fast API round trip doesn't flash the UI.
 */
export const startMinimumHold = (ms: number): (() => Promise<void>) => {
    const start = Date.now();

    return async () => {
        const remaining = ms - (Date.now() - start);
        if (remaining > 0) {
            await new Promise((resolve) => setTimeout(resolve, remaining));
        }
    };
};
